import React from 'react';
import ClientUsageDashboard from '../../components/client/ClientUsageDashboard';

const ClientUsagePage = () => {
  return (
    <div className="p-8">
      <ClientUsageDashboard />
    </div>
  );
};

export default ClientUsagePage;
